import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import styles from '../../../styles'
import classNames from 'classnames'
import { ClassValue } from 'classnames/types'
import { useMediaQuery } from 'react-responsive'
import { Theme } from '@material-ui/core'

const useStyle = makeStyles<Theme, { hasButton: boolean }>(
	(theme) => (
		{
			...styles(theme),
			cardStyle: {
				marginBottom: 20,
				display: 'flex'
			},
			cardLargeScreenStyle: {
				marginRight: 40
			},
			cardHeaderStyle: {
				width: '100%',
				'& div:first-child': {
					paddingRight: '10px'
				},
				'& h2': {
					margin: 0
				},
				'& img': {
					width: '56px',
					height: '56px'
				}
			},
			cardHeaderLargeScreenStyle: {
				padding: '30px 20px 25px 30px'
			},
			cardHeaderSmallScreenStyle: {
				padding: 25
			},
			selectedStyle: {
				color: theme.palette.blue.main,
				border: `1px solid ${theme.palette.blue.main}`,

				'&:hover': {
					background: theme.palette.dynamic.main,
					border: `1px solid ${theme.palette.dynamic.main}`,
					color: 'white',

					'& .blocImg svg path': {
						fill: 'white'
					}
				}
			},
			multiSelectedStyle: {
				color: theme.palette.blue.main,
				border: `1px solid ${theme.palette.blue.main}`,

				'&:hover': {
					border: props => `1px solid ${props.hasButton ? theme.palette.green.main : theme.palette.dynamic.main}`
				}
			},
			isSelected: {
				backgroundColor: props => `${props.hasButton ? theme.palette.green.main : theme.palette.dynamic.main} !important`,
				border: props => `1px solid ${props.hasButton ? theme.palette.green.main : theme.palette.dynamic.main}`,
				color: 'white'
			},
			bgWhite: {
				backgroundColor: 'white'
			},
			bgGrey: {
				backgroundColor: theme.palette.blue['5'],
				border: `1px solid ${theme.palette.blue['50']}`,
				color: theme.palette.blue['50']
			}
		}
	)
)

interface AcceptingProps {
	blocDescription: React.ReactChild,
	img?: React.ReactChild,
	setSelected: () => void,
	isOther?: boolean,
	multiSelect?: boolean,
	isSelected?: boolean,
	hasButton?: boolean
}

type CardPropertyProps = AcceptingProps

const CardStep: React.FC<CardPropertyProps> = (
	{
		blocDescription,
		img,
		setSelected,
		isOther,
		multiSelect = false,
		isSelected = false,
		hasButton = false
	}
) => {
	const classes = useStyle({hasButton})
	const isLargeScreen = useMediaQuery(
		{
			query: '(min-width: 1025px)'
		}
	)

	const cardClass: ClassValue = classNames(
		'col-xs-12 col-md-5',
		classes.cardStyle,
		classes.cursorPointer,
		multiSelect ? classes.multiSelectedStyle : classes.selectedStyle,
		isOther ? [classes.bgGrey] : [classes.bgWhite],
		{
			[classes.cardLargeScreenStyle]: isLargeScreen,
			[classes.isSelected]: isSelected
		}
	)
	const cardHeaderClass = classNames(
		{
			[classes.cardHeaderLargeScreenStyle]: isLargeScreen,
			[classes.cardHeaderSmallScreenStyle]: !isLargeScreen
		},
		classes.cardHeaderStyle,
		classes.flex,
		classes.alignCenter,
		classes.flexBetween
	)

	return (
		<div
			className={cardClass}
			onClick={setSelected}
		>
			<div className={cardHeaderClass}>
				<div>
					{blocDescription}
				</div>

				{
					img &&
					<div className="blocImg">
						{img}
					</div>
				}
			</div>
		</div>
	)
}

export default CardStep
